import React, { Component } from 'react';
import { ApiHelper } from '../helpers/ApiHelper';
import { Helper } from '../helpers/Helper';
import { StyleSheet, css } from 'aphrodite';

import Dialog from '@material-ui/core/Dialog';

import { DynamicForm } from './DynamicForm';
import { AppStyles, AppTheme } from '../../styles/AppTheme';

export class DynamicFormDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {}
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  onCloseModal() {
    this.setState({
      screenMessage: ''
    });
    this.props.onClosed();
  }

  render() {
    // console.log(this.props.formDefinition);
    // console.log('window.innerWidth:', window.innerWidth)
    let dialogHeading = 'Add/Edit/Delete'
    if (this.props.formDefinition.title) {
      dialogHeading = this.props.formDefinition.title
    }
    return (
      <Dialog
        open={this.props.isOpen}
        aria-labelledby={this.props.formDefinition.steps[0].title}
        fullWidth={true}
        fullScreen={window.innerWidth && window.innerWidth < 480 ? true : false}
        maxWidth='md'
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          {/* <div className={css(Styles.modalTitle)}>{this.props.formDefinition.steps[0].title}</div> */}
          <div className={css(Styles.modalTitle)}>{dialogHeading}</div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal} disabled={this.state.inProcess}>
            <svg className={css(Styles.modalCloseIcon)} viewBox='0 0 36 36'>
              <path d='M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z'></path>
            </svg>
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          {this.props.isOpen ? <DynamicForm {...this.props}/> : ''}
        </div>
      </Dialog>
    );
  }
}

const Styles = StyleSheet.create({
  modalHeader: {
    backgroundColor: 'whitesmoke',
    padding: 10
  },
  modalTitle: {
    color: 'black',
    fontSize: 20,
  },
  modalContent: {
    paddingLeft: 10,
    paddingRight: 10
  },
  modalCloseButton: {
    position: 'absolute',
    top: 8,
    right: 5,
    border: 'none',
    padding: 0,
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer'
  },
  modalCloseIcon: {
    width: 28,
    height: 28
  }
})



// WEBPACK FOOTER //
// ./src/common/components/DynamicFormDialog.js